import { Checkbox } from '@mui/material'
import { ReactComponent as CheckBox } from 'assets/icons/checkBox.svg'
import CheckBoxActive from 'assets/icons/checkBoxActive'
import { roundingNumber } from 'components/shared/processes'
import { LactationStatus } from 'models'
import React, { useEffect } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { lactationStatuses } from '../processes'
import RangeInputs from './RangeInputs'
const icon = <CheckBox />
const checkedIcon = <CheckBoxActive />

const LactationContentBlock = props => {
	const {
		lactation,
		availableLactationValues,
		handleDayChange,
		toggleFilter,
		turnOnFilters,
		setActiveFilters,
	} = props

	const isDisabledLactationStatus = lactation.statuses.includes(
		LactationStatus.NonLactating,
	)
	useEffect(() => {
		const lactationStatuses = lactation.statuses
		lactationStatuses.includes(LactationStatus.Lactating) &&
			!isDisabledLactationStatus &&
			(!lactationStatuses.includes(LactationStatus.CommercialMilk) ||
				!lactationStatuses.includes(LactationStatus.DefectiveMilk)) &&
			turnOnFilters('lactation', [
				LactationStatus.CommercialMilk,
				LactationStatus.DefectiveMilk,
			])

		isDisabledLactationStatus &&
			(lactationStatuses.includes(LactationStatus.CommercialMilk) ||
				lactationStatuses.includes(LactationStatus.DefectiveMilk)) &&
			setActiveFilters(prev => {
				return {
					...prev,
					lactation: {
						...prev.lactation,
						statuses: prev.lactation.statuses.filter(
							el =>
								el !== LactationStatus.CommercialMilk &&
								el !== LactationStatus.DefectiveMilk,
						),
					},
				}
			})
	}, [lactation.statuses])
	return (
		<>
			<TypographyPrimary sx={{ marginBottom: '16px' }}>
				День лактации
			</TypographyPrimary>
			<RangeInputs
				startValue={lactation.startOf}
				endValue={lactation.endOf}
				availableStart={availableLactationValues?.startOf}
				availableEnd={availableLactationValues?.endOf}
				formatValue={value => roundingNumber(value, 0)}
				onStartChange={e => handleDayChange(e, 'lactation', 'startOf')}
				onEndChange={e => handleDayChange(e, 'lactation', 'endOf')}
			/>
			<ul>
				{lactationStatuses.map((status, index) => (
					<React.Fragment key={status.id}>
						{index === 0 && (
							<TypographyPrimary sx={{ margin: '24px 0px 8px 0px' }}>
								Статус доения
							</TypographyPrimary>
						)}
						{index === 2 && (
							<TypographyPrimary
								sx={{
									color: isDisabledLactationStatus ? COLORS.secondary : 'none',
									margin: '16px 0px 8px 0px',
								}}
							>
								Молоко
							</TypographyPrimary>
						)}
						<li
							key={status.id}
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								padding: '6px 0px',
							}}
						>
							<Checkbox
								onClick={() => toggleFilter('lactation', status.key)}
								icon={icon}
								checkedIcon={checkedIcon}
								disableTouchRipple={isDisabledLactationStatus}
								disableRipple
								style={{
									padding: '0px 8px 0px 0px',
									margin: '0px',
									pointerEvents:
										isDisabledLactationStatus && (index === 2 || index === 3)
											? 'none'
											: 'auto',
								}}
								checked={lactation.statuses.includes(status.key)}
							/>

							<TypographyPrimary
								sx={{
									color:
										isDisabledLactationStatus && (index === 2 || index === 3)
											? COLORS.secondary
											: 'none',
								}}
							>
								{status.title}
							</TypographyPrimary>
						</li>
					</React.Fragment>
				))}
			</ul>
		</>
	)
}

export default LactationContentBlock
